// Angaben am 11.10.2026 gegen Konfiguration, Quellcode und veröffentlichte Anbieterinformationen abgeglichen.
export function Datenschutz() {
  return (
    <article className="seite">
      <h1>Datenschutzerklärung</h1>
      <p className="hinweis-klein">Stand: 11. Oktober 2026</p>

      <h2>1. Verantwortlicher</h2>
      <p>
        GQL Gussone Quecke Legal Partnerschaft von Rechtsanwälten mbB, Rubensstraße 114, 12157 Berlin.
        Ansprechpartner für den Datenschutz ist Rechtsanwalt Moritz Quecke unter dieser Anschrift oder per E-Mail an{' '}
        <a href="mailto:quecke@gql-partner.de">quecke@gql-partner.de</a>.
      </p>

      <h2>2. Zweck des Portals und Herkunft der Daten</h2>
      <p>
        Über dieses Portal stellen eingeladene Personen Unterlagen zu Brandmeldeanlagen-Aufschaltungen bereit,
        insbesondere Verträge, Rechnungen und Entgeltmitteilungen. GQL verwendet diese für die in der gesonderten
        Vereinbarung genannten Zwecke: das Verfahren Berlin Rights &amp; Claims GmbH gegen Bosch Sicherheitssysteme
        GmbH, Kammergericht U 3/26 Kart, sowie die vereinbarten Vergleichsmarktanalysen und Ersteinschätzungen.
      </p>
      <p>
        Kontaktdaten erhalten wir von Ihnen oder der Organisation, die Sie für die Zusammenarbeit benennt.
        Angaben zu weiteren Personen stammen aus den bereitgestellten Unterlagen. Für den Zugang ist die
        dienstliche E-Mail-Adresse erforderlich; ohne diese kann GQL keinen Zugang einrichten. Name und
        Organisation können zur Zuordnung verarbeitet werden. Welche Unterlagen bereitzustellen sind,
        richtet sich nach der gesonderten Vereinbarung.
      </p>

      <h2>3. Verarbeitete Daten</h2>
      <ul>
        <li>
          <strong>Nutzerkonto:</strong> Name, dienstliche E-Mail-Adresse, Organisation, Rolle, zugeordnete Standorte
          sowie Zeitpunkt und Fassung der bestätigten Vertraulichkeitshinweise.
        </li>
        <li>
          <strong>Anmeldung:</strong> Prüfsummen und Gültigkeitsfristen der einmaligen Anmelde- und Einladungslinks,
          ein technisch notwendiges Sitzungscookie und der Zeitpunkt der letzten Aktivität.
        </li>
        <li>
          <strong>Unterlagen und Auswertungen:</strong> verschlüsselt abgelegte Dateien, erkannter Text,
          abgeleitete Angaben wie Beträge, Zeiträume und Komponenten sowie Prüfentscheidungen von GQL.
          Unterlagen können Daten Dritter enthalten, etwa Namen von Ansprechpartnern oder Unterschriften.
        </li>
        <li>
          <strong>Handlungs- und Betriebsprotokolle:</strong> Nutzer- und Objektkennungen, Aktion, Zeitpunkt,
          Berechtigungsänderungen und technische Statusangaben. Sie dienen der Nachvollziehbarkeit von Zugriffen,
          Bearbeitung und Löschung; Dokumentinhalte und Anmeldegeheimnisse werden darin nicht protokolliert.
        </li>
        <li>
          <strong>Zugriffsprotokolle des Webservers:</strong> IP-Adresse, Zeitpunkt, Methode, aufgerufener Pfad,
          Antwortstatus, Datenmenge und Dauer. Cookies, Autorisierungsangaben, übrige Anfrageheader und
          Suchparameter der Adresse werden aus diesem Protokoll entfernt.
        </li>
      </ul>

      <h2>4. Rechtsgrundlagen</h2>
      <p>
        Soweit Sie selbst Vertragspartei sind, verarbeiten wir die zur Vertragserfüllung erforderlichen Daten
        nach Art. 6 Abs. 1 lit. b DSGVO. Bei Beschäftigten und Ansprechpartnern der beteiligten Organisationen
        sowie bei Daten Dritter in den Unterlagen beruht die Verarbeitung auf Art. 6 Abs. 1 lit. f DSGVO.
        Berechtigte Interessen sind die Durchführung der vereinbarten Zusammenarbeit, die Geltendmachung und
        Verteidigung von Rechtsansprüchen, die vereinbarte fachliche Auswertung und der sichere Betrieb des Portals.
        Dies gilt auch für die Protokollierung und die von Ihnen aufgerufene Kartendarstellung.
      </p>
      <p>
        Soweit gesetzliche Aufbewahrungspflichten bestehen, beruht die weitere Speicherung auf Art. 6 Abs. 1 lit. c
        DSGVO. Die Bestätigung der Vertraulichkeitshinweise ist keine pauschale datenschutzrechtliche Einwilligung.
      </p>

      <h2>5. Empfänger und eingesetzte Dienste</h2>
      <p>
        Zugriff auf die Unterlagen erhalten die hierfür berechtigten Personen bei GQL und, im Umfang der
        vereinbarten Zusammenarbeit, die berechtigten Portalnutzer. Eine Verwendung gegenüber Mandanten, Gerichten
        oder anderen Verfahrensbeteiligten richtet sich nach der gesonderten Vereinbarung und den geltenden
        Vertraulichkeitspflichten.
      </p>
      <ul>
        <li>
          <strong>Hetzner Online GmbH, Gunzenhausen:</strong> Der Portalserver und die Dateiablage befinden sich in
          Helsinki, Finnland. Verschlüsselte Sicherungen werden getrennt in Falkenstein, Deutschland, gespeichert.
        </li>
        <li>
          <strong>Microsoft Ireland Operations Ltd.:</strong> Microsoft 365 übermittelt Anmelde-, Einladungs- und
          Hinweis-E-Mails. Dabei werden Empfängeradresse und Nachrichteninhalt verarbeitet. Die Hinweis-E-Mails
          enthalten keine hochgeladenen Unterlagen.
        </li>
        <li>
          <strong>Amazon Web Services EMEA SARL:</strong> Für ergänzende Auswertungen nutzt GQL Amazon Bedrock mit
          den Modellen Claude Haiku 4.5 und Claude Sonnet 4.6. Erkannter Text und erforderliche Seitenbilder werden
          ausschließlich über Inferenzprofile innerhalb der EU verarbeitet. Nach den veröffentlichten Angaben von
          AWS werden Eingaben und Ausgaben dieser Modelle im Regelbetrieb nicht dauerhaft gespeichert und nicht
          zum Modelltraining verwendet; der Modellanbieter erhält darauf keinen Zugriff. AWS behält sich bestimmte
          Speicherungen und Überprüfungen zur Missbrauchserkennung vor. Näheres enthalten die{' '}
          <a href="https://docs.aws.amazon.com/bedrock/latest/userguide/data-retention.html">Angaben zur Speicherung</a>{' '}
          und zur{' '}
          <a href="https://docs.aws.amazon.com/bedrock/latest/userguide/abuse-detection.html">Missbrauchserkennung</a>.
        </li>
        <li>
          <strong>OpenStreetMap Foundation, Vereinigtes Königreich:</strong> Beim Öffnen der Karte lädt Ihr Browser
          Kartenkacheln von tile.openstreetmap.org. Dabei werden insbesondere IP-Adresse, Browserinformationen,
          Zeitpunkt und der abgerufene Kartenausschnitt an den Kartendienst übermittelt. Dieser verwendet auch ein
          weltweit verteiltes Auslieferungsnetz. Die Einzelheiten beschreibt die{' '}
          <a href="https://osmfoundation.org/wiki/Privacy_Policy">Datenschutzerklärung der OpenStreetMap Foundation</a>.
          Die übrigen Portalansichten können ohne Öffnen der Karte genutzt werden.
        </li>
        <li>
          <strong>pro|nodes GmbH, Volkmaroder Straße 8c, 38104 Braunschweig:</strong> Übernommene Unterlagen werden
          in der Kanzleisoftware jur|nodes in der elektronischen Verfahrensakte abgelegt. Der Anbieter betreibt die
          Cloud nach seinen <a href="https://www.jur-nodes.de/funktionen/sicherheit_support">Angaben zur Datensicherheit</a>{' '}
          in Rechenzentren in Deutschland.
        </li>
      </ul>
      <p>
        Bei international tätigen Dienstleistern können insbesondere für Support, Sicherheit und die Auslieferung
        von Karten Daten außerhalb der EU oder des EWR verarbeitet werden. Soweit hierfür kein
        Angemessenheitsbeschluss der Europäischen Kommission gilt, erfolgen solche Übermittlungen auf Grundlage
        geeigneter Garantien, insbesondere der EU-Standardvertragsklauseln. Informationen zu den einschlägigen
        Garantien und eine Kopie erhalten Sie beim Verantwortlichen unter Nr. 1.
      </p>

      <h2>6. Speicherdauer und Löschung</h2>
      <ul>
        <li>
          <strong>Zugänge:</strong> Anmeldelinks gelten 30 Minuten, Einladungslinks sieben Tage und jeweils nur einmal.
          Sitzungen gelten höchstens sieben Tage und werden nach 24 Stunden Inaktivität ungültig. Diese Fristen
          begrenzen den Zugang; sie bedeuten keine gleichzeitige Löschung aller zugehörigen Nachweise. Beim Abmelden
          wird die jeweilige Sitzung gelöscht, bei einer Kontosperre werden alle Sitzungen und noch offenen Links entfernt.
        </li>
        <li>
          <strong>Unterlagen und Auswertungen im Portal:</strong> Die Löschung wird von GQL entsprechend der
          gesonderten Vereinbarung veranlasst: zwölf Monate nach rechtskräftigem Abschluss der Verfahren, in denen
          die Unterlagen verwendet wurden, spätestens zwölf Monate nach Ende der Vereinbarung. In die anwaltliche
          Handakte übernommene Kopien unterliegen gesonderten gesetzlichen Aufbewahrungspflichten; ihre Löschung
          erfolgt nicht bereits durch den Löschlauf im Portal.
        </li>
        <li>
          <strong>Konten und Nachweise:</strong> Nach Wegfall der Zugangsberechtigung sperrt GQL das Konto.
          Kontodaten, Standortzuordnungen und Handlungsnachweise bleiben nur so lange erhalten, wie sie für die
          vereinbarten Zwecke, den Nachweis von Berechtigungen und Vertraulichkeitsbestätigungen oder die Klärung
          von Rechtsansprüchen erforderlich sind. GQL prüft dies beim Abschluss der Zusammenarbeit und veranlasst
          die dann erforderliche Löschung oder Anonymisierung gesondert.
        </li>
        <li>
          <strong>Protokolle:</strong> Die gesonderten Webzugriffsprotokolle werden täglich rotiert und höchstens
          14 Tage aufbewahrt; bei hohem Datenaufkommen kann die Aufbewahrung kürzer ausfallen. Betriebsprotokolle
          und gesicherte Nachweise konkreter Sicherheitsvorfälle bleiben, soweit erforderlich, bis zum Abschluss
          der Fehler- oder Vorfallklärung erhalten. Für das Handlungsprotokoll gelten die vorstehenden Kriterien
          für Konten und Nachweise.
        </li>
        <li>
          <strong>Sicherungen:</strong> Es werden 30 tägliche verschlüsselte Sicherungsstände aufbewahrt.
          Gelöschte Daten verschwinden aus diesen Sicherungen schrittweise mit neuen erfolgreichen Sicherungen;
          die Sicherungskopien stehen nicht für die laufende Portalnutzung zur Verfügung.
        </li>
      </ul>

      <h2>7. Cookies und Reichweitenmessung</h2>
      <p>
        Das Portal setzt ein technisch notwendiges, gegen Skriptzugriff geschütztes Sitzungscookie, das nur über
        verschlüsselte Verbindungen übertragen wird. GQL setzt im Portal keine Werbe- oder Analysewerkzeuge ein.
        Zur optionalen Kartenansicht beachten Sie bitte Nr. 5.
      </p>

      <h2>8. Ihre Rechte</h2>
      <p>
        Sie können unter den gesetzlichen Voraussetzungen Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16),
        Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18) und Datenübertragbarkeit (Art. 20) verlangen.
        Gegen Verarbeitungen auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO können Sie aus Gründen, die sich aus Ihrer
        besonderen Situation ergeben, Widerspruch einlegen (Art. 21). Wenden Sie sich dazu an den Verantwortlichen
        unter Nr. 1. Gesetzliche Einschränkungen, insbesondere zum Schutz der anwaltlichen Verschwiegenheit und
        der Rechte anderer Personen, bleiben unberührt.
      </p>
      <p>
        Sie können sich außerdem bei einer Datenschutzaufsichtsbehörde beschweren, etwa bei der Berliner
        Beauftragten für Datenschutz und Informationsfreiheit, Alt-Moabit 59–61, 10555 Berlin,{' '}
        <a href="https://www.datenschutz-berlin.de">www.datenschutz-berlin.de</a>.
      </p>

      <h2>9. Keine automatisierte Entscheidung</h2>
      <p>
        Die automatische Auswertung sortiert Unterlagen vor und schlägt Werte vor. Jede Übernahme wird von GQL
        geprüft. Eine ausschließlich automatisierte Entscheidung mit rechtlicher oder vergleichbar erheblicher
        Wirkung für Sie findet nicht statt.
      </p>
    </article>
  );
}
